var _linearGradient, _linearGradient2, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _linearGradient3, _linearGradient4, _linearGradient5, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaMissouriLotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 521 521",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 0.017,
    x2: 0.5,
    y2: 0.89
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a6bb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#043a79"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    y1: 0.501,
    x2: 1,
    y2: 0.501
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89e28"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 185.915,
    cy: 410.023,
    r: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee3d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad2921"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 307.915,
    cy: 348.523,
    r: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee3d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad2921"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 426.415,
    cy: 310.023,
    r: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee3d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad2921"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 515.415,
    cy: 343.023,
    r: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee3d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad2921"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 545.915,
    cy: 436.523,
    r: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee3d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad2921"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0,
    y1: 0.499,
    x2: 1.001,
    y2: 0.499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee3d34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad2921"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.002,
    y1: 0.499,
    x2: 1.002,
    y2: 0.499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89e28"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d89e28"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e9b258",
    d: "M444.612 345.581c-2.284-5.384-5.547-10.197-9.707-14.439-4.323-4.242-9.299-7.423-14.928-9.707-5.629-2.121-11.665-3.263-18.028-3.263-6.526 0-12.562 1.06-18.109 3.263-5.547 2.284-10.441 5.547-14.765 9.707-2.202 2.284-4.16 4.65-5.792 7.179V320.13H237.251v12.807c-.571-.653-1.142-1.224-1.713-1.795-4.487-4.242-9.626-7.423-15.336-9.707-5.792-2.121-11.991-3.263-18.599-3.263-6.689 0-12.889 1.06-18.68 3.263-5.71 2.284-10.768 5.547-15.254 9.707-4.323 4.323-7.668 9.136-10.034 14.439-2.202 5.384-3.345 11.257-3.345 17.62 0 5.058.734 9.87 2.121 14.275h-27.083v-57.999H102.49v85.816h61.833v-13.786c1.06 1.224 2.202 2.447 3.345 3.671 4.568 4.242 9.707 7.505 15.336 9.707 5.792 2.202 11.991 3.345 18.599 3.345a52.109 52.109 0 0 0 18.517-3.345c5.873-2.284 10.931-5.547 15.336-9.626a46.27 46.27 0 0 0 10.034-14.52c2.366-5.384 3.508-11.176 3.508-17.538 0-5.302-.816-10.278-2.366-15.01h13.541v57.754h26.838v-57.754h23.902v57.754h26.756v-57.754h20.72c-1.55 4.65-2.284 9.626-2.284 15.01 0 6.444 1.06 12.318 3.263 17.62 2.202 5.221 5.465 9.952 9.707 14.275 4.487 4.242 9.381 7.505 14.928 9.707 5.629 2.202 11.665 3.345 18.028 3.345a49.36 49.36 0 0 0 17.946-3.345 46.59 46.59 0 0 0 14.846-9.626c4.16-4.16 7.423-8.973 9.707-14.52 2.284-5.384 3.426-11.176 3.426-17.538s-1.224-12.155-3.345-17.538zM212.29 374.948c-2.774 2.937-6.363 4.405-10.849 4.405s-8.076-1.468-10.849-4.405c-2.692-3.018-4.079-6.934-4.079-11.747 0-4.976 1.387-8.892 4.079-11.91 2.855-2.937 6.444-4.487 10.849-4.487s8.076 1.468 10.849 4.487c2.692 2.937 4.079 6.934 4.079 11.91 0 4.813-1.387 8.81-4.079 11.747zm200.182 0c-2.692 2.937-6.118 4.405-10.523 4.405-4.323 0-7.831-1.468-10.523-4.405-2.61-3.018-3.916-6.934-3.916-11.747 0-4.976 1.305-8.892 3.916-11.91 2.774-2.937 6.281-4.487 10.523-4.487 4.323 0 7.831 1.468 10.523 4.487 2.61 2.937 3.916 6.934 3.916 11.91 0 4.813-1.305 8.81-3.916 11.747z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M440.207 340.116c-2.284-5.384-5.547-10.197-9.707-14.439-4.323-4.242-9.299-7.423-14.928-9.707-5.629-2.121-11.665-3.263-18.028-3.263-6.526 0-12.562 1.06-18.109 3.263-5.547 2.284-10.441 5.547-14.765 9.707-2.202 2.284-4.16 4.65-5.792 7.179v-18.191H232.846v12.807c-.571-.653-1.142-1.224-1.713-1.795-4.487-4.242-9.626-7.423-15.336-9.707-5.792-2.121-11.991-3.263-18.599-3.263-6.689 0-12.889 1.06-18.68 3.263-5.71 2.284-10.768 5.547-15.254 9.707-4.323 4.323-7.668 9.136-10.034 14.439-2.202 5.384-3.345 11.257-3.345 17.62 0 5.058.734 9.87 2.121 14.275h-27.083v-57.917H98.086v85.816h61.751v-13.786c1.06 1.224 2.202 2.447 3.345 3.671 4.568 4.242 9.707 7.505 15.336 9.707 5.792 2.202 11.991 3.345 18.599 3.345a52.109 52.109 0 0 0 18.517-3.345c5.873-2.284 10.931-5.547 15.336-9.626a46.27 46.27 0 0 0 10.034-14.52c2.366-5.384 3.508-11.176 3.508-17.538 0-5.302-.816-10.278-2.366-15.01h13.786v57.754h26.838v-57.754h23.902v57.754h26.838v-57.754h20.475c-1.55 4.65-2.284 9.626-2.284 15.01 0 6.444 1.06 12.318 3.263 17.62 2.202 5.221 5.465 9.952 9.707 14.275 4.487 4.242 9.381 7.505 14.928 9.707 5.629 2.202 11.665 3.345 18.028 3.345a49.36 49.36 0 0 0 17.946-3.345 46.59 46.59 0 0 0 14.846-9.626c4.16-4.16 7.423-8.973 9.707-14.52 2.284-5.384 3.426-11.176 3.426-17.538s-1.142-12.155-3.345-17.62zm-232.241 29.448c-2.774 2.937-6.363 4.405-10.849 4.405s-8.076-1.468-10.849-4.405c-2.692-3.018-4.079-6.934-4.079-11.747 0-4.976 1.387-8.892 4.079-11.91 2.855-2.937 6.444-4.487 10.849-4.487s8.076 1.468 10.849 4.487c2.692 2.937 4.079 6.934 4.079 11.91-.082 4.813-1.387 8.728-4.079 11.747zm200.101 0c-2.692 2.937-6.118 4.405-10.523 4.405-4.323 0-7.831-1.468-10.523-4.405-2.61-3.018-3.916-6.934-3.916-11.747 0-4.976 1.305-8.892 3.916-11.91 2.774-2.937 6.281-4.487 10.523-4.487 4.323 0 7.831 1.468 10.523 4.487 2.61 2.937 3.916 6.934 3.916 11.91 0 4.813-1.305 8.728-3.916 11.747z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#b)",
    cx: 166.69,
    cy: 269.636,
    r: 13.868
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#b)",
    cx: 221.345,
    cy: 292.885,
    r: 13.868
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#b)",
    cx: 369.809,
    cy: 273.715,
    r: 13.868
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#b)",
    cx: 417.53,
    cy: 290.845,
    r: 13.868
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#b)",
    cx: 459.132,
    cy: 380.577,
    r: 13.868
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#b)",
    cx: 84.3,
    cy: 386.287,
    r: 13.868
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#b)",
    cx: 67.578,
    cy: 310.831,
    r: 13.868
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#c)",
    cx: 61.868,
    cy: 361.407,
    r: 13.868
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#d)",
    cx: 161.388,
    cy: 311.239,
    r: 13.868
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#e)",
    cx: 258.053,
    cy: 279.833,
    r: 13.868
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#f)",
    cx: 330.654,
    cy: 306.752,
    r: 13.868
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#g)",
    cx: 355.534,
    cy: 383.024,
    r: 13.868
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M385.063 229.42c0-5.629 2.039-10.441 6.036-14.52s8.892-6.036 14.52-6.036c5.71 0 10.605 2.039 14.683 6.036s6.118 8.892 6.118 14.602-2.039 10.605-6.118 14.602c-4.079 4.079-8.973 6.036-14.683 6.036-5.629 0-10.441-2.039-14.52-6.2-3.997-4.16-6.036-8.973-6.036-14.52z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M437.76 124.435c0-3.181 1.142-5.955 3.426-8.239s5.058-3.426 8.239-3.426c3.263 0 6.036 1.142 8.402 3.426s3.508 5.058 3.508 8.321-1.142 6.036-3.508 8.321-5.139 3.426-8.402 3.426c-3.181 0-5.955-1.142-8.239-3.508-2.202-2.447-3.426-5.221-3.426-8.321z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M312.707 402.602c0-8.973-7.342-16.315-16.315-16.315s-16.315 7.342-16.315 16.315c0 1.142.163 2.284.326 3.426h31.977c.245-1.142.326-2.202.326-3.426z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaMissouriLotto);
export default __webpack_public_path__ + "static/media/usa_missouri_lotto.40661ea24fd235e8b14762589131d219.svg";
export { ForwardRef as ReactComponent };